module.exports = __webpack_public_path__ + "img/icon-bed.03e66bc3.svg";